import Vue from "vue";
import App from "./App.vue";
import VueResoerce from "vue-resource";
import { router } from "./routes";
import { store } from "./store/store";
import Pagination from "vue-pagination-2";
import Vuelidate from "vuelidate";
import Multiselect from "vue-multiselect";

import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

import VueCarousel from "vue-carousel";

Vue.use(VueCarousel);
Vue.use(VueSidebarMenu);

Vue.use(Vuelidate);
Vue.component("pagination", Pagination);
Vue.component("multiselect", Multiselect);

Vue.use(VueResoerce);

Vue.http.options.root = process.env.VUE_APP_API;

Vue.http.interceptors.push((request, next) => {
  request.headers.set("site", localStorage.getItem("site"));
  request.headers.set("token", localStorage.getItem("token"));

  next(response => {
    if (response.status == 401) {
      store.commit("setMessage", response.body);
      store.dispatch("logout");
    }
  });
});

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js